import { Box, Chip, Typography } from "@mui/material";
import Colors from "assets/colors";

const STATUS_CONFIG = {
  pending: {
    color: Colors.warning,
    textColor: Colors.warningText,
    bg: Colors.warningBg,
    border: Colors.warningBorder,
    chipLabel: "Pending",
    message: "Pending admin review and approval",
    chipColor: "warning",
  },
  live: {
    color: Colors.success,
    textColor: Colors.success,
    bg: Colors.successBg,
    border: Colors.success,
    chipLabel: "Live",
    message: "This movie is currently live and visible to users.",
    chipColor: "success",
  },
  rejected: {
    color: Colors.error,
    textColor: Colors.errorText,
    bg: Colors.errorBg,
    border: Colors.error,
    chipLabel: "Rejected",
    message: "This listing has been rejected",
    chipColor: "error",
  },
  unpublished: {
    color: Colors.secondary,
    textColor: Colors.textSecondary,
    bg: Colors.background,
    border: Colors.border,
    chipLabel: "Unpublished",
    message: "This movie is unpublished and not visible to users.",
    chipColor: "default",
  },
  archived: {
    color: Colors.disabled,
    textColor: Colors.textSecondary,
    bg: Colors.background,
    border: Colors.border,
    chipLabel: "Archived",
    message: "This movie has been archived and is no longer active.",
    chipColor: "default",
  },
  upcoming: {
    color: Colors.info,
    textColor: Colors.info,
    bg: "#D9F0FF", // light info background
    border: Colors.info,
    chipLabel: "Upcoming",
    message: "This movie is scheduled to go live soon.",
    chipColor: "info",
  },
  announced: {
    color: Colors.accent,
    textColor: Colors.textPrimary,
    bg: "#FFF5D9", // light accent background
    border: Colors.accent,
    chipLabel: "Announced",
    message: "This movie has been announced but not yet scheduled.",
    chipColor: "primary",
  },
  draft: {
    color: Colors.secondary,
    textColor: Colors.textSecondary,
    bg: "#F0F0F0", // light grey background
    border: Colors.border,
    chipLabel: "Draft",
    message: "This movie is saved as a draft and not visible to users.",
    chipColor: "default",
  },
};

interface StatusBannerProps {
  status: 'pending' | 'rejected' | 'live' | 'unpublished' | 'archived' | 'upcoming' | 'announced' | 'draft' | string;
}

function StatusBanner({ status }: StatusBannerProps) {
  const normalizedStatus = status?.toLowerCase() || 'pending';
  const config = STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.pending;
  
  return (
    <Box
      sx={{
        color: config.textColor,
        backgroundColor: config.bg,
        border: `solid 1px ${config.border}`,
      }}
      className="!flex gap-3 items-center px-5 py-3 rounded-md"
    >
      <Chip
        variant="outlined"
        label={config.chipLabel}
        className="font-bold"
        sx={{
          border: `1.5px solid ${config.color}`,
          borderRadius: 2,
          color: config.color, '& .MuiChip-label': {
            fontWeight: '600'
          },
        }}
      />
      <Typography color={config.color}>{config.message}</Typography>
    </Box>
  );
}

export default StatusBanner;